module.exports = __webpack_public_path__ + "img/M007-08_jrb-02_02.7d8a1f64.jpg";